// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verify_parent {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.table_block {
  background: white;
}

table {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
  word-wrap: break-word;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

td {
  padding: 8px;
  font-size: 14px;
  text-align: left;
  width: 20%;
}

tr:first-child {
  border-bottom: none;
}

tr {
  border-bottom: solid 1px rgba(0, 0, 0, 0.12);
}

.photopass {
  height: 120px;
  width: 90px;
  background-size: cover;
}

.test-ecp-block-true {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 44px;
}

.test-ecp-block-true p {
  padding: 0 20px;
}

.verification-container-success {
  background-color: #c1efbb;
}

.verification-container-warning {
  background-color: #efdfbb;
}

.verification-container-error {
  background-color: #ffbbbb;
}

.verification-item {
  font-weight: 900;
  margin: 0px 5px;
}

.verification-item-success {
  color: green;
}

.verification-container-success .verification-item-error {
  color: green;
}

.verification-container-warning .verification-item-error {
  color: #807800;
}

.verification-container-error .verification-item-error {
  color: #800000;
}

.active {
  background: #ffbbbb;
}

.active td {
  color: red;
}

tr:nth-last-child(-n+1) {
  border-bottom: none;
}

tr:first-child td {
  background: #448aff;
  color: white;
  border-bottom: none;
  border-right: solid 1px white;
}

tr:first-child td:last-child {
  border-right: none;
}

tr:nth-child(2) {
  height: 140px;
}

td {
  border-right: solid 1px rgba(0, 0, 0, 0.12);
}

td:last-child {
  border-right: none;
}

.restartChip {
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/dev/pass-verify/pass.verify.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AACA;EACE,iBAAA;AAEF;;AAAA;EACI,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,qCAAA;AAGJ;;AADA;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AAIJ;;AAFA;EACE,mBAAA;AAKF;;AAHA;EACI,4CAAA;AAMJ;;AAJA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;AAOJ;;AAJA;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAOJ;;AALA;EACI,eAAA;AAQJ;;AANA;EACI,yBAAA;AASJ;;AAPA;EACI,yBAAA;AAUJ;;AARA;EACI,yBAAA;AAWJ;;AATA;EACI,gBAAA;EAAkB,eAAA;AAatB;;AAXA;EACI,YAAA;AAcJ;;AAZA;EACI,YAAA;AAeJ;;AAbA;EACI,cAAA;AAgBJ;;AAdA;EACI,cAAA;AAiBJ;;AAfA;EACI,mBAAA;AAkBJ;;AAhBA;EACI,UAAA;AAmBJ;;AAjBA;EACI,mBAAA;AAoBJ;;AAlBA;EACI,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;AAqBJ;;AAnBA;EACI,kBAAA;AAsBJ;;AApBA;EACI,aAAA;AAuBJ;;AArBA;EACE,2CAAA;AAwBF;;AAtBA;EACE,kBAAA;AAyBF;;AAvBA;EACE,aAAA;EACA,mBAAA;AA0BF","sourcesContent":[".verify_parent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.table_block {\n  background: white;\n}\ntable {\n    border-collapse: collapse;\n    width: 100%;\n    table-layout: fixed;\n    word-wrap: break-word;\n    border: 1px solid rgba(0,0,0,.12);\n}\ntd {\n    padding: 8px;\n    font-size: 14px;\n    text-align: left;\n    width: 20%;\n}\ntr:first-child {\n  border-bottom: none;\n}\ntr {\n    border-bottom: solid 1px rgba(0, 0, 0, 0.12);\n}\n.photopass {\n    height: 120px;\n    width: 90px;\n    background-size: cover;\n}\n\n.test-ecp-block-true {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    min-height: 44px;\n}\n.test-ecp-block-true p {\n    padding: 0 20px;\n}\n.verification-container-success {\n    background-color:#c1efbb;\n}\n.verification-container-warning {\n    background-color:#efdfbb;\n}\n.verification-container-error {\n    background-color:#ffbbbb;\n}\n.verification-item {\n    font-weight: 900; margin: 0px 5px;\n}\n.verification-item-success {\n    color: green;\n}\n.verification-container-success .verification-item-error {\n    color: green;\n}\n.verification-container-warning .verification-item-error {\n    color: #807800;\n}\n.verification-container-error .verification-item-error {\n    color: #800000;\n}\n.active {\n    background: #ffbbbb;\n}\n.active td {\n    color: red;\n}\ntr:nth-last-child(-n+1) {\n    border-bottom: none;\n}\ntr:first-child td {\n    background: #448aff;\n    color: white;\n    border-bottom: none;\n    border-right: solid 1px white;\n}\ntr:first-child td:last-child {\n    border-right: none;\n}\ntr:nth-child(2) {\n    height: 140px;\n}\ntd {\n  border-right: solid 1px rgba(0, 0, 0, 0.12);\n}\ntd:last-child {\n  border-right: none;\n}\n.restartChip {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
